module.exports = __webpack_public_path__ + "static/media/commGreyCircle.24f3e95d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/commGreyCircle.svg
// module id = 835
// module chunks = 0